export function trackEvent(_event: string, _properties?: Record<string, unknown>): void {
  if (typeof window === 'undefined') return;

  const win = window as typeof window & {
    zaraz?: { track?: (event: string, properties?: Record<string, unknown>) => void };
    posthog?: { capture?: (event: string, properties?: Record<string, unknown>) => void };
  };

  if (win.zaraz?.track) {
    win.zaraz.track(_event, _properties);
    return;
  }

  if (win.posthog?.capture) {
    win.posthog.capture(_event, _properties);
  }
}

export const AnalyticsEvents = {
  footerProgramsClicked: () => {
    trackEvent('footer_programs_clicked');
  },
};
